import React from "react";
import logo from "../Assetss/Logo.png";
import { CONSTANTS_STRINGS } from "../../Utils/Constant";

function Footer() {
  const footerData = CONSTANTS_STRINGS.footer;

  return (
    <div
      className="bg-[#24283e] text-white md:relative absolute md:h-[600px] md:py-15"
      style={{ clipPath: "polygon(0% 0, 100% 0%, 100% 100%, 0 100%)" }}
    >
      <div className="w-full md:fixed md:h-[600px] bottom-0 mx-auto px-4 sm:px-6 lg:px-8 ">
        <div className="grid grid-cols-1 md:grid-cols-3 xl:px-30 ">
          {/* First Section */}
          <div className="md:pr-6 lg:border-r-2 md:border-b-2 border-gray-700 space-y-6 py-10 md:pt-20 ">
            <img src={logo} alt="logo" className="w-44" />
            <p className="text-gray-400 text-sm md:text-base">
              {footerData.description}
            </p>
            <div>
              <p className="text-xs text-gray-400">Our address</p>
              <p className="text-sm md:text-base">{footerData.address}</p>
            </div>
            <div className="md:flex flex-col gap-6 sm:gap-10 pb-6 md:pb-0">
              <div>
                <p className="text-xs text-gray-400">Support 24/7</p>
                <p className="text-sm md:text-base">{footerData.phone}</p>
              </div>
              <div>
                <p className="text-xs text-gray-400">Email Address</p>
                <p className="text-sm md:text-base">{footerData.email}</p>
              </div>
            </div>
          </div>

          {/* Second Section */}
          <div className="md:px-6 lg:border-r-2 md:border-b-2 border-gray-700 grid grid-cols-2 gap-8 py-10 md:py-20 px-4 sm:px-0">
            <div>
              <p className="text-sm md:text-base font-semibold mb-4">
                Categories
              </p>
              <ul className="space-y-3 text-sm md:text-base text-gray-400">
                {footerData.categories.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-sm md:text-base font-semibold mb-4">
                Quick Links
              </p>
              <ul className="space-y-3 text-sm md:text-base text-gray-400">
                {footerData.quickLinks.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </div>

          {/* Third Section */}
          <div className="space-y-6 border-b-2 border-gray-700 py-10 md:py-20 px-4">
            <p className="text-base md:text-lg font-semibold">
              {footerData.subscribeTitle}
            </p>
            <input
              type="email"
              placeholder={footerData.subscribePlaceholder}
              className="w-auto p-3 bg-gray-700 text-white rounded-full outline-none focus:ring-2 focus:ring-green-500 text-sm md:text-base"
            />
            <p className="text-gray-400 text-xs w-[250px] md:text-sm">
              {footerData.subscribeText}
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center md:px-30 py-6 text-gray-400 text-sm md:text-base">
          <p className="mb-4 md:mb-0 text-center md:text-left">
            {footerData.copyrightText}
            <span className="text-green-600">
              {" "}
              {footerData.copyrightOwner}
            </span>{" "}
            All rights reserved
          </p>
          <ul className="md:flex justify-center gap-4 md:gap-5">
            {footerData.policies.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Footer;
